import {Directive, ViewContainerRef} from '@angular/core';

@Directive({standalone: true, selector: '[pubPreamble]'})
export class PreambleDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
